import { backendURL } from "../config";
import httpservice from "./httpservice";

class PublicService {
  getTaxes(params = {}) {
    return httpservice.get(`${backendURL}/public/firs/taxes`, { params });
  }

  getCountries(params = {}) {
    return httpservice.get(`${backendURL}/public/countries`, { params });
  }

  async getStates(params = {}) {
    return await httpservice.get(`${backendURL}/public/states-by-country`, { params });
  }
  async getCities(params = {}) {
    return await httpservice.get(`${backendURL}/public/cities-by-state`, { params });
  }

  async getHSCode(params = {}) {
    return await httpservice.get(`${backendURL}/public/firs/hs-codes`, { params });
  }

  async getServiceCodes(params = {}) {
    return await httpservice.get(`${backendURL}/public/firs/service-codes`, { params });
  }

  async getQuantityCodes(params = {}) {
    return await httpservice.get(`${backendURL}/public/firs/quantity-codes`, { params });
  }
}

export default new PublicService();
